/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import { ButtonGroup, Divider, IconButton, Popover, Radio, RadioGroup } from '@coursera/cds-core';

import {
  filterGradingStatusValues,
  useSearchContext,
} from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/SearchContext';
import type { FilterGradingStatus } from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/SearchContext';

import _t from 'i18n!nls/grading';

const styles = {
  divider: css`
    margin-bottom: var(--cds-spacing-150);
  `,
  popoverContainer: css`
    width: 300px;
  `,
};

const FiltersControl = () => {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(null);
  const { filters, setFilters } = useSearchContext();
  const [radioValue, setRadioValue] = useState<FilterGradingStatus>(filters.gradingStatus);

  const handleApply = () => {
    setFilters({ ...filters, gradingStatus: radioValue });
    setPopoverAnchor(null);
  };
  const handleReset = () => {
    setRadioValue('all');
    setFilters({ ...filters, gradingStatus: 'all' });
    setPopoverAnchor(null);
  };

  useEffect(() => {
    setRadioValue(filters.gradingStatus);
  }, [filters.gradingStatus]);

  const gradingStatuses = Object.keys(filterGradingStatusValues) as unknown as FilterGradingStatus[];

  return (
    <React.Fragment>
      <IconButton
        variant="secondary"
        aria-label={_t('Filters')}
        intent="filter"
        onClick={(e) => setPopoverAnchor(e.currentTarget)}
      />

      <Popover open={Boolean(popoverAnchor)} anchorElement={popoverAnchor} onClose={() => setPopoverAnchor(null)}>
        <Popover.Body component="div" tabIndex={0} css={styles.popoverContainer}>
          <RadioGroup
            value={radioValue}
            label={_t('Grading status')}
            onChange={(e) => setRadioValue(e.target.value as FilterGradingStatus)}
          >
            {gradingStatuses.map((item) => (
              <Radio key={item} value={item} label={filterGradingStatusValues[item]} />
            ))}
          </RadioGroup>

          <Divider color="dark" css={styles.divider} />

          <ButtonGroup
            aria-label={_t('Button group displays a submit and clear all buttons')}
            size="small"
            primaryButtonProps={{
              children: _t('Apply'),
              onClick: handleApply,
            }}
            alternateButtonProps={{
              children: _t('Reset'),
              variant: 'ghost',
              onClick: handleReset,
            }}
          />
        </Popover.Body>
      </Popover>
    </React.Fragment>
  );
};

export default FiltersControl;
